import React from 'react';
import SuccessDotIcon from '@assets/icons/dots/accepted.svg';
import ActivationDotIcon from '@assets/icons/dots/activation.svg';
import PendingDotIcon from '@assets/icons/dots/pending.svg';
import FailureDotIcon from '@assets/icons/dots/rejected.svg';
import WarningDotIcon from '@assets/icons/dots/warning.svg';

import type { ActionType } from '../types.ts';
import { ACTION_TYPES } from './constants.ts';
import { TableActionWrapper, Title } from './styled.tsx';

interface Props {
    type: ActionType;
}

const ACTION_LABELS: Partial<Record<ActionType, string>> = {
    [ACTION_TYPES.ResettedDefault]: 'Resetted-default',
    [ACTION_TYPES.RePublished]: 'Re-published',
    [ACTION_TYPES.ReActivated]: 'Re-activated',
    [ACTION_TYPES.AutoDeactivated]: 'Auto-deactivated',
};

export const getFormattedLabel = (actionType: ActionType): string => {
    return ACTION_LABELS[actionType] ?? actionType;
};

const getActionIcon = (actionType: ActionType): React.ReactElement => {
    switch (actionType) {
        case ACTION_TYPES.Published:
        case ACTION_TYPES.ReActivated:
            return <SuccessDotIcon />;
        case ACTION_TYPES.ResettedDefault:
        case ACTION_TYPES.Draft:
            return <WarningDotIcon />;
        case ACTION_TYPES.Deleted:
            return <FailureDotIcon />;
        case ACTION_TYPES.Edited:
        case ACTION_TYPES.RePublished:
            return <PendingDotIcon />;
        case ACTION_TYPES.Deactivated:
        case ACTION_TYPES.Activated:
        case ACTION_TYPES.AutoDeactivated:
            return <ActivationDotIcon />;
        case ACTION_TYPES.Archive:
        default:
            return <ActivationDotIcon />;
    }
};

const Action: React.FC<Props> = ({ type }) => {
    return (
        <TableActionWrapper type={type}>
            {getActionIcon(type)}
            <Title type={type}>{getFormattedLabel(type)}</Title>
        </TableActionWrapper>
    );
};

export default Action;
